var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M7.18 11.9c0 .47.38.85.84.85.47 0 .85-.38.85-.85 0-.46-.38-.84-.85-.84-.46 0-.84.38-.84.84zM8.75 6c0-.42-.33-.75-.75-.75-.4 0-.75.34-.75.74v3c0 .4.33.73.75.73.4 0 .75-.34.75-.74V6zM7.5 2.37c.28-.5.72-.5 1 0l6 10.74c.28.5.05.9-.5.9H2c-.55 0-.78-.4-.5-.9l6-10.72z"}));
}

Warning.defaultProps = {"width":"50","height":"50","viewBox":"0 0 16 16"};

module.exports = Warning;

Warning.default = Warning;
